export const currencyMultiplierMapping = {
    BIF: 1,
    CLF: 1,
    DJF: 1,
    GNF: 1,
    ISK: 1,
    JPY: 1,
    KMF: 1,
    KRW: 1,
    PYG: 1,
    RWF: 1,
    UGX: 1,
    VUV: 1,
    VND: 1,
    XAF: 1,
    XOF: 1,
    XPF: 1,
    BHD: 1000,
    IQD: 1000,
    JOD: 1000,
    KWD: 1000,
    LYD: 1000,
    OMR: 1000,
    TND: 1000,
};
